<!-- Gratification banner: only shown after exchange validation -->
<div *ngIf="showBanner" class="gratification-banner">

  <!-- PROPIETARIO: puede enviar gratificación -->
  <ng-container *ngIf="showSendCard">
    <ion-card class="gratification-card send-card">
      <ion-card-content>
        <div class="flex flex-col gap-2">
          <div class="flex items-center gap-2">
            <ion-icon name="gift-outline" color="secondary" class="text-xl"></ion-icon>
            <ion-label class="text-sm font-medium text-[#131C4F]">
              {{ t.getItemTranslated(canResumePendingPayment ? 'GRATIFICATION.RESUME_TITLE' : 'GRATIFICATION.SEND_TITLE') || 'Send a gratification' }}
            </ion-label>
          </div>
          <ion-label class="text-xs text-[#6B7280]">
            {{ t.getItemTranslated(canResumePendingPayment ? 'GRATIFICATION.RESUME_DESCRIPTION' : 'GRATIFICATION.SEND_DESCRIPTION') || 'Thank the finder with a voluntary gratification (max €200).' }}
          </ion-label>

          <ion-label class="text-xs text-[#6B7280] italic mt-1">
            {{ t.getItemTranslated('GRATIFICATION.SEND_FOOTER') || 'Completely optional. The Finder does not expect it or require it.' }}
          </ion-label>

          <div *ngIf="!showSendForm" class="flex justify-end mt-1">
            <ion-button size="small" color="secondary" (click)="toggleSendForm()">
              {{ t.getItemTranslated(canResumePendingPayment ? 'GRATIFICATION.RESUME_BUTTON' : 'GRATIFICATION.SEND_BUTTON') || 'Send gratification' }}
            </ion-button>
          </div>

          <div *ngIf="showSendForm" class="send-form mt-2">
            <ion-item lines="none" class="amount-item">
              <ion-input
                type="number"
                [min]="MIN_AMOUNT"
                [max]="MAX_AMOUNT"
                step="0.50"
                [(ngModel)]="amountInput"
                [placeholder]="t.getItemTranslated('GRATIFICATION.AMOUNT_PLACEHOLDER') || 'Amount (€)'"
              ></ion-input>
            </ion-item>
            <div class="flex items-center gap-1 mt-1 px-1">
              <ion-icon name="information-circle-outline" color="medium" class="text-sm shrink-0"></ion-icon>
              <ion-label class="text-[11px] text-[#6B7280]">
                {{ t.getItemTranslated('GRATIFICATION.MAX_AMOUNT_INFO') || 'For security, the maximum allowed amount is €200.' }}
              </ion-label>
            </div>
            <div class="flex gap-2 mt-2 justify-end">
              <ion-button size="small" fill="outline" color="medium" (click)="toggleSendForm()" [disabled]="loading">
                {{ t.getItemTranslated('COMMON.CANCEL') || 'Cancel' }}
              </ion-button>
              <ion-button size="small" color="secondary" (click)="requestSendConfirmation()" [disabled]="loading || !amountInput">
                <ion-spinner *ngIf="loading" name="crescent" class="w-4 h-4 mr-1"></ion-spinner>
                {{ t.getItemTranslated(canResumePendingPayment ? 'GRATIFICATION.RESUME_CONFIRM' : 'GRATIFICATION.CONFIRM_SEND') || 'Send' }}
              </ion-button>
            </div>
          </div>
        </div>
      </ion-card-content>
    </ion-card>
  </ng-container>

  <app-dialog [show]="showSendConfirmDialog" [close]="true" cssClass="gratification-confirm-modal" (toggle)="cancelSendConfirmation()">
    <div class="gratification-confirm-dialog text-left">
      <h3 class="gratification-confirm-title">{{ 'GRATIFICATION.MODAL_TITLE' | translate }}</h3>
      <p class="gratification-confirm-subtitle">{{ 'GRATIFICATION.MODAL_SUBTITLE' | translate }}</p>

      <div class="gratification-amount-card">
        <span class="gratification-amount-label">{{ 'GRATIFICATION.MODAL_AMOUNT_LABEL' | translate }}</span>
        <strong class="gratification-amount-value">{{ formatAmount(amountInput || 0) }}</strong>
      </div>

      <div class="gratification-info-card">
        <div class="gratification-info-title-row">
          <ion-icon name="help-circle-outline" class="gratification-info-icon"></ion-icon>
          <span class="gratification-info-title">{{ 'GRATIFICATION.MODAL_INFO_TITLE' | translate }}</span>
        </div>
        <p class="gratification-info-copy">{{ 'GRATIFICATION.MODAL_INFO_BODY_1' | translate }}</p>
        <p class="gratification-info-copy">{{ 'GRATIFICATION.MODAL_INFO_BODY_2' | translate }}</p>
      </div>

      <div class="gratification-secure-row">
        <ion-icon name="lock-closed-outline" class="gratification-secure-icon"></ion-icon>
        <span class="gratification-secure-copy">{{ 'GRATIFICATION.MODAL_SECURE_PAYMENT' | translate }}</span>
      </div>

      <label class="gratification-terms-row">
        <input type="checkbox" [(ngModel)]="sendTermsAccepted" class="gratification-terms-checkbox" />
        <span class="gratification-terms-copy" (click)="openTerms($event)" [innerHTML]="'GRATIFICATION.MODAL_TERMS_LABEL' | translate"></span>
      </label>

      <ion-button expand="block" color="primary" class="gratification-confirm-button" [disabled]="!sendTermsAccepted || loading" (click)="confirmSendGratification()">
        {{ 'GRATIFICATION.MODAL_CONFIRM_BUTTON' | translate }}
      </ion-button>

      <p class="gratification-confirm-footer">{{ 'GRATIFICATION.MODAL_FOOTER' | translate }}</p>
    </div>
  </app-dialog>

  <!-- ESTADOS CON GRATIFICACIÓN EXISTENTE -->
  <ng-container *ngIf="gratification">

    <!-- Pendiente de aceptación: SENDER ve que espera, RECEIVER ve pantalla informativa + botones -->
    <ion-card *ngIf="isPendingAcceptance" class="gratification-card pending-card">
      <ion-card-content>
        <div class="flex flex-col gap-2">

          <!-- Título e importe -->
          <div class="flex items-center gap-2">
            <ion-icon name="gift-outline" color="warning" class="text-xl"></ion-icon>
            <ion-label class="text-sm font-medium text-[#131C4F]">
              <ng-container *ngIf="isReceiver">
                {{ t.getItemTranslated('GRATIFICATION.RECEIVED_TITLE') || 'Has recibido una gratificación' }}
              </ng-container>
              <ng-container *ngIf="isSender">
                {{ t.getItemTranslated('GRATIFICATION.PENDING_TITLE') || 'Gratificación pendiente' }}
              </ng-container>
            </ion-label>
          </div>

          <!-- Importe destacado -->
          <div class="gratif-amount">
            {{ formatAmount(gratification.amount) }}
          </div>

          <!-- SENDER: espera -->
          <ion-label *ngIf="isSender" class="text-xs text-[#6B7280] italic">
            {{ t.getItemTranslated('GRATIFICATION.WAITING_ACCEPTANCE') || 'Esperando a que el Finder acepte o rechace.' }}
          </ion-label>

          <!-- RECEIVER: pantalla informativa con estado de Stripe Connect -->
          <ng-container *ngIf="isReceiver">

            <!-- Comprobando Stripe -->
            <div *ngIf="connectLoading" class="connect-status-row checking">
              <ion-spinner name="lines-small" class="connect-spinner"></ion-spinner>
              <ion-label class="text-xs text-[#6B7280]">
                {{ t.getItemTranslated('GRATIFICATION.CONNECT_CHECKING') || 'Comprobando cuenta Stripe...' }}
              </ion-label>
            </div>

            <!-- Stripe Connect LISTO -->
            <div *ngIf="!connectLoading && connectState !== null && isConnectReady" class="connect-status-row ready">
              <ion-icon name="checkmark-circle" color="success" class="connect-icon"></ion-icon>
              <ion-label class="text-xs text-[#16A34A]">
                {{ t.getItemTranslated('GRATIFICATION.CONNECT_READY') || 'Tu cuenta Stripe está configurada. La transferencia se realizará de forma automática.' }}
              </ion-label>
            </div>

            <!-- Stripe Connect NO listo -->
            <div *ngIf="!connectLoading && connectState !== null && !isConnectReady" class="connect-status-box not-ready">
              <div class="flex items-start gap-2">
                <ion-icon name="warning-outline" color="warning" class="connect-icon mt-0.5 shrink-0"></ion-icon>
                <ion-label class="text-xs text-[#92400E]">
                  {{ t.getItemTranslated('GRATIFICATION.CONNECT_NOT_READY_INFO') || 'Para recibir el importe debes completar el alta de tu cuenta Stripe en un plazo de 5 días. De lo contrario, la gratificación será devuelta al propietario.' }}
                </ion-label>
              </div>
              <div class="flex justify-end mt-2">
                <ion-button size="small" color="warning" fill="solid" (click)="openConnectOnboarding()">
                  <ion-icon name="open-outline" slot="start"></ion-icon>
                  {{ t.getItemTranslated('GRATIFICATION.CONNECT_SETUP_BUTTON') || 'Completar cuenta' }}
                </ion-button>
              </div>
            </div>

            <!-- Aceptar / Rechazar -->
            <div class="flex gap-2 mt-2 justify-end">
              <ion-button size="small" fill="outline" color="danger" (click)="rejectGratification()" [disabled]="loading">
                {{ t.getItemTranslated('GRATIFICATION.REJECT_BUTTON') || 'Rechazar' }}
              </ion-button>
              <ion-button size="small" color="secondary" (click)="acceptGratification()" [disabled]="loading">
                <ion-spinner *ngIf="loading" name="crescent" class="w-4 h-4 mr-1"></ion-spinner>
                {{ t.getItemTranslated('COMMON.OK') || 'Aceptar' }}
              </ion-button>
            </div>

          </ng-container>
        </div>
      </ion-card-content>
    </ion-card>

    <!-- Aceptada: esperando configuración de Stripe Connect -->
    <ion-card *ngIf="isAccepted" class="gratification-card accepted-card">
      <ion-card-content>
        <div class="flex flex-col gap-2">
          <div class="flex items-center gap-2">
            <ion-icon name="card-outline" color="secondary" class="text-xl"></ion-icon>
            <ion-label class="text-sm font-medium text-[#131C4F]">
              {{ t.getItemTranslated('GRATIFICATION.ACCEPTED_TITLE') || 'Gratification accepted' }}
            </ion-label>
          </div>
          <ion-label class="text-xs text-[#6B7280]">
            {{ formatAmount(gratification.amount) }}
          </ion-label>

          <!-- Receiver: necesita configurar Stripe Connect -->
          <ng-container *ngIf="isReceiver">
            <ion-label class="text-xs text-[#F59E0B]">
              {{ t.getItemTranslated('GRATIFICATION.CONNECT_NEEDED') || 'Set up your account to receive the funds.' }}
            </ion-label>
            <div class="flex gap-2 mt-1 justify-end">
              <ion-button size="small" color="secondary" (click)="retryTransfer()" [disabled]="loading">
                <ion-spinner *ngIf="loading" name="crescent" class="w-4 h-4 mr-1"></ion-spinner>
                {{ t.getItemTranslated('GRATIFICATION.RETRY_TRANSFER') || 'Retry transfer' }}
              </ion-button>
            </div>
          </ng-container>

          <!-- Sender: espera -->
          <ion-label *ngIf="isSender" class="text-xs text-[#6B7280] italic">
            {{ t.getItemTranslated('GRATIFICATION.WAITING_CONNECT') || 'The finder is setting up their account to receive the transfer.' }}
          </ion-label>
        </div>
      </ion-card-content>
    </ion-card>

    <!-- Transferida: éxito -->
    <ion-card *ngIf="isTransferred" class="gratification-card success-card">
      <ion-card-content>
        <div class="flex items-center gap-2">
          <ion-icon name="checkmark-circle" color="success" class="text-xl"></ion-icon>
          <ion-label class="text-sm font-medium text-[#131C4F]">
            {{ t.getItemTranslated('GRATIFICATION.TRANSFERRED_TITLE') || 'Gratification transferred' }}
          </ion-label>
          <ion-label class="text-xs text-[#6B7280] ml-auto">
            {{ formatAmount(gratification.amount) }}
          </ion-label>
        </div>
      </ion-card-content>
    </ion-card>

    <!-- Rechazada -->
    <ion-card *ngIf="isRejected || isRefunded" class="gratification-card refunded-card">
      <ion-card-content>
        <div class="flex items-center gap-2">
          <ion-icon name="close-circle" color="medium" class="text-xl"></ion-icon>
          <ion-label class="text-sm font-medium text-[#6B7280]">
            {{ (isRejected
              ? (t.getItemTranslated('GRATIFICATION.REJECTED_TITLE') || 'Gratification rejected')
              : (t.getItemTranslated('GRATIFICATION.REFUNDED_TITLE') || 'Gratification refunded'))
            }}
          </ion-label>
          <ion-label class="text-xs text-[#6B7280] ml-auto">
            {{ formatAmount(gratification.amount) }}
          </ion-label>
        </div>
      </ion-card-content>
    </ion-card>

    <!-- Expirada -->
    <ion-card *ngIf="isExpired" class="gratification-card expired-card">
      <ion-card-content>
        <div class="flex items-center gap-2">
          <ion-icon name="time-outline" color="warning" class="text-xl"></ion-icon>
          <ion-label class="text-sm font-medium text-[#6B7280]">
            {{ t.getItemTranslated('GRATIFICATION.EXPIRED_TITLE') || 'Gratification expired' }}
          </ion-label>
          <ion-label class="text-xs text-[#6B7280] ml-auto">
            {{ formatAmount(gratification.amount) }}
          </ion-label>
        </div>
      </ion-card-content>
    </ion-card>

  </ng-container>
</div>
